  <div mat-dialog-content>
    <p style="font-size:15px;"><b>{{message}}</b></p>
  </div>
  
  <div mat-dialog-actions>
    <button  mat-raised-button color="primary" cdkFocusInitial (click)="onDismiss()">Close</button>
  </div>